// extracted by mini-css-extract-plugin
module.exports = {"carousel__item":"carousel-item_carousel__item__3e19w"};